import { MessagesData } from 'interfaces/messagesData';
import React, { useContext } from 'react';
import Chart from 'react-apexcharts';
import ApexCharts from 'apexcharts';
import ptBr from 'apexcharts/dist/locales/pt-br.json';
import en from 'apexcharts/dist/locales/en.json';
import la from 'apexcharts/dist/locales/es.json';
import { LanguageContext } from 'contexts/LanguageContext';
import CrossSellInsights from 'components/CrossSellBanners/CrossSellInsights';
import { Row } from 'antd';

interface Props {
	messagesData: MessagesData;
}

export function SendingTypesLineChart({ messagesData }: Props) {
	const { dictionary } = useContext(LanguageContext);

	const getOptions = (): ApexCharts.ApexOptions => {
		if (!messagesData) {
			return {};
		}

		const xaxis = [];

		for (const year of Object.keys(messagesData)) {
			for (const month of Object.keys(messagesData[year])) {
				const label = formatDateForLabel(month, year);
				xaxis.push(label);
			}
		}

		const locale = dictionary.locale;
		const title = dictionary.chart_sending_types_title;

		return {
			title: { text: title },
			chart: {
				id: 'sending-types',
				background: '#fff',
				defaultLocale: locale,
				locales: [ptBr, en, la],
				toolbar: {
					offsetY: 30,
				},
			},
			xaxis: {
				categories: xaxis,
				range: 12,
			},
			grid: {
				padding: { bottom: -10 },
			},
			yaxis: {
				labels: {
					formatter: (value: number) => {
						let newValue;
						if (value) {
							newValue = value.toLocaleString();
						}
						return newValue ?? String(value);
					},
					offsetX: -15,
				},
			},
			stroke: {
				width: 2,
			},
		};
	};

	const formatDateForLabel = (month: string, year: string) => {
		let formattedMonth = month;
		if (Number(month) < 10) {
			formattedMonth = '0' + month;
		}

		const formattedYear = year.slice(-2);

		return `${formattedMonth}/${formattedYear}`;
	};

	const getSeries = () => {
		if (!messagesData) {
			return [];
		}

		const automationSeries = [];
		const campaignSeries = [];
		const audioSentSeries = [];

		for (const year of Object.keys(messagesData)) {
			for (const month of Object.keys(messagesData[year])) {
				automationSeries.push(messagesData[year][month].automacao);
				campaignSeries.push(messagesData[year][month].campanha);
				audioSentSeries.push(messagesData[year][month].audio_in_chat);
			}
		}

		const automation = dictionary.chart_automation;
		const campaign = dictionary.chart_campaign;
		const audio = dictionary.chart_audio;

		return [
			{ name: automation, data: automationSeries },
			{ name: campaign, data: campaignSeries },
			{ name: audio, data: audioSentSeries },
		];
	};

	return (
		<>
			<Row>
				<div className="chartWrapper">
					<Chart
						options={getOptions()}
						series={getSeries()}
						type="line"
						width="100%"
						height="100%"
					/>
				</div>
			</Row>

			<Row style={{ marginTop: '10px' }}>
				<CrossSellInsights />
			</Row>
		</>
	);
}
